module.exports = __webpack_public_path__ + "assets/img/example4.61b8dd6a.jpg";